/**
 * Build-time config. CRA inlines REACT_APP_* at build time.
 *
 * - keycloak: "Login as CPO" redirect target
 * - brand: marketing brand variant for this build
 * - locale: language/region variant for this build
 * - frontendAppUrl: operator app after Keycloak login (full origin, no trailing slash stored)
 * - driverAppUrl: driver app for "Login as Driver"; empty = same origin + /driver at runtime
 */
const supportedBrands = ["chargewhisper", "cargaclara"];
const supportedLocales = ["en", "es-AR"];

const brand = supportedBrands.includes(process.env.REACT_APP_BRAND)
  ? process.env.REACT_APP_BRAND
  : "chargewhisper";
const locale = supportedLocales.includes(process.env.REACT_APP_LOCALE)
  ? process.env.REACT_APP_LOCALE
  : brand === "cargaclara"
    ? "es-AR"
    : "en";

const realm = process.env.REACT_APP_KEYCLOAK_REALM || "ocpp-connector";
const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "ocpp-frontend";

/** URL of the operator frontend (redirect after Keycloak login). */
const frontendAppUrl = process.env.REACT_APP_FRONTEND_APP_URL || "http://localhost:3000";
/** URL of the driver app for "Login as Driver". Empty = use same origin + /driver at runtime. */
const driverAppUrl = (process.env.REACT_APP_DRIVER_APP_URL || "").trim();

export const config = {
  brand,
  locale,
  keycloak: {
    url: process.env.REACT_APP_KEYCLOAK_URL || "http://localhost:8081",
    realm,
    clientId,
  },
  frontendAppUrl: frontendAppUrl.replace(/\/$/, ""),
  driverAppUrl,
};
